import { useDispatch } from "react-redux";
import { auth, provider } from "./firebase";
import { signInWithPopup } from "firebase/auth";
import { FcGoogle } from "react-icons/fc";
import { registerUser } from "../actions/userActions";

const FireBaseGoogle = () => {
  const dispatch = useDispatch();

  // const handleSignIn = async () => {
  //   try {
  //     const result = await signInWithPopup(auth, provider);
  //     const user = result.user;

  //     if (user) {
  //       dispatch(registerUser(user));
  //     }

  //     console.log("User Info:", user);
  //   } catch (error) {
  //     console.error("Login Failed:", error.message);
  //   }
  // };

  const handleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      if (user) {
        dispatch(registerUser(user));
      }

      console.log("User Info:", user);
    } catch (error) {
      console.error("Login Failed:", error.message);
    }
  };

  return (
    <div>
      <div
        className=" w-full  h-12 flex justify-center items-center rounded-md border border-gray-400 mt-8 mb-4 focus:outline-none hover:border-gray-200 group"
        onClick={handleSignIn}
      >
        {/* {loading ? (
          <CircularProgress size={30} sx={{ color: "black" }} />
        ) : ( */}
        <div className="flex justify-center items-center text-gray-500 text-sm group-hover:text-gray-400">
          <FcGoogle className="w-5 h-5 mx-1 text-gray-600 group-hover:opacity-70" />
          <p>Google Login</p>
        </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default FireBaseGoogle;
